import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_user_notifications_list = _resolveComponent("user-notifications-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, {
    icon: "fa fa-bell",
    color: "grey-8",
    round: "",
    dense: "",
    flat: ""
  }, {
    default: _withCtx(() => [
      (_ctx.numUnread)
        ? (_openBlock(), _createBlock(_component_q_badge, {
            key: 0,
            color: "red",
            "text-color": "white",
            label: _ctx.numUnread,
            floating: ""
          }, null, 8, ["label"]))
        : _createCommentVNode("", true),
      _createVNode(_component_q_menu, null, {
        default: _withCtx(() => [
          _createVNode(_component_user_notifications_list, {
            "user-id": _ctx.userId,
            "user-notifications": _ctx.userNotifications,
            total: _ctx.numUnread,
            onMarkedOneRead: _ctx.markRead,
            onMarkedRead: _ctx.markAllRead
          }, null, 8, ["user-id", "user-notifications", "total", "onMarkedOneRead", "onMarkedRead"])
        ]),
        _: 1
      }),
      _createVNode(_component_q_tooltip, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.tooltip), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}